import { StandardEvents } from '@shopify/events';

/* Shopify calcula descuentos reales; el precio no incluye envío. */
const SELECTOR = '.essentia-native-continue [data-essentia-checkout-total]';
const base = window.Shopify?.routes?.root || '/';
const cartUrl = (base.endsWith('/') ? base : base + '/') + 'cart.js';
const guarani = new Intl.NumberFormat('es-PY', { maximumFractionDigits: 0 });
let revision = 0;
let latestCart = null;

function money(cart) {
  const subunits = Number(cart?.total_price);
  if (!Number.isFinite(subunits)) return null;
  const currency = String(cart.currency || 'PYG').toUpperCase();
  if (currency === 'PYG') return 'Gs. ' + guarani.format(Math.round(subunits / 100));
  try {
    return new Intl.NumberFormat('es-PY', { style: 'currency', currency }).format(subunits / 100);
  } catch {
    return null;
  }
}

function display(cart) {
  const total = money(cart);
  const visible = Boolean(total && Number(cart.item_count) > 0);
  document.querySelectorAll(SELECTOR).forEach((element) => {
    const label = visible ? 'Total sin envío: ' + total : '';
    if (element.textContent !== label) element.textContent = label;
    element.hidden = !visible;
  });
}

async function refresh() {
  const current = ++revision;
  try {
    const response = await fetch(cartUrl, {
      credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) return;
    const cart = await response.json();
    if (current !== revision) return;
    latestCart = cart;
    display(cart);
  } catch {
    // Conserva el precio Liquid anterior hasta que el carrito vuelva a responder.
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
  try { if (event.promise) await event.promise; } catch { return; }
  refresh();
});
document.addEventListener('theme-drawer:open', refresh);
window.addEventListener('pageshow', refresh);
document.addEventListener('focus', refresh);
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') refresh();
});

function init() {
  const observer = new MutationObserver(() => {
    if (latestCart) display(latestCart);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  refresh();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
